import React from "react";
const NewArrivalsCarousel = React.lazy(() => import('./components/Vault/NewArrivalsCarousel' /* webpackChunkName: "NewArrivalsCarousel" */));
import {BrowserRouter as Router } from "react-router-dom";
const BuyingSection = React.lazy(() => import('./BuyingSection' /* webpackChunkName: "BuyingSection" */));
const Financing = React.lazy(() => import('./components/AffirmFinancing' /* webpackChunkName: "AffirmFinancing" */));
const StyleAssembly = React.lazy(() => import('./components/StyleAssembly' /* webpackChunkName: "StyleAssembly" */));
const TrendingCarousel = React.lazy(() => import('./components/Vault/TrendingCarousel' /* webpackChunkName: "TrendingCarousel" */));
const CustomCarousel = React.lazy(() => import('./components/Vault/CustomCarousel' /* webpackChunkName: "CustomCarousel" */));
const RebagStylist = React.lazy(() => import('./components/RebagStylist' /* webpackChunkName: "RebagStylist" */));
import "./sass/App.scss"
const ClairTrade = React.lazy(() => import('./components/ClairTrade' /* webpackChunkName: "ClairTrade" */));
const OfferCoupon = React.lazy(() => import('./components/OfferCoupon' /* webpackChunkName: "OfferCoupon" */));

const All = ({
                 vault_homepage_trending,
                 vault_homepage_new_arrivals,
                 vault_custom_slider,
                 financing,
                 style_assembly,
                 pdp,
                 rebag_stylist,
                 renderElement,
                 clair_trade,
                 offer_coupon,
                 plp,
    }) => {

    return (
        <>
            {(pdp || plp) &&
            <Router basename="/buying-section">
                <BuyingSection />
            </Router>
            }
            {financing &&
            <Router>
                <Financing/>
            </Router>
            }
            {style_assembly &&
            <Router>
                <StyleAssembly/>
            </Router>
            }
            {rebag_stylist &&
            <Router>
                <RebagStylist/>
            </Router>
            }
            {clair_trade &&
            <Router>
                <ClairTrade/>
            </Router>
            }
            {offer_coupon &&
            <Router>
                <OfferCoupon/>
            </Router>
            }
            {vault_homepage_trending &&
            <Router>
                <TrendingCarousel/>
            </Router>
            }
            {vault_homepage_new_arrivals &&
            <Router>
                <NewArrivalsCarousel/>
            </Router>
            }
            {vault_custom_slider &&
            <Router>
                <CustomCarousel
                    renderElement={renderElement}
                />
            </Router>
            }
        </>
    );
};

export default All;